import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import OurTeam from "./pages/OurTeam";
import PatientResources from "./pages/PatientResources";
import Services from "./pages/Services";
import VitalityClass from "./pages/VitalityClass";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import Accessibility from "./pages/Accessibility";
import Disclaimer from "./pages/Disclaimer";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { Head } from "./components/Head";
import Contact from "./pages/Contact";
import GeneralInquiry from "./pages/GeneralInquiry";
import VitalityInquiry from "./pages/VitalityInquiry";
import { ScrollToTop } from "./components/ScrollToTop";

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <>
      <ScrollToTop />
      <Head />
      <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/services"} component={Services} />
      <Route path={"/vitality-class"} component={VitalityClass} />
      <Route path={"/our-team"} component={OurTeam} />
      <Route path={"/patient-resources"} component={PatientResources} />
      <Route path={"/blog"} component={Blog} />
      <Route path={"/blog/:slug"} component={BlogArticle} />
      <Route path={"/privacy"} component={Privacy} />
      <Route path={"/terms"} component={Terms} />
      <Route path={"/disclaimer"} component={Disclaimer} />
      <Route path={"/accessibility"} component={Accessibility} />
      <Route path={"/contact"} component={Contact} />
      <Route path={"/inquiry"} component={GeneralInquiry} />
      <Route path={"/vitality-inquiry"} component={VitalityInquiry} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
      </Switch>
    </>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
        // switchable
      >
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
